module.exports = __webpack_public_path__ + "static/assets/7318fc38eeca19704bca37e61c899e86.png";